import {IReg, REG} from "lib/commons/registry";
import {IItemUiEnv} from "back/wsp/views/itemMain";
import {IJmlNode, IJmlSubSet} from "lib/commons/xml/jml";
import {IXmlMsg} from "lib/edit/ot/xmlHouse";
import {AgEltBoxSelection} from "back/edit/wed/features/boxSel";
import {Action} from "lib/commons/actions";
import {EWedletEditMode, isEditableWedlet, IWedletActionCtx} from "back/edit/wed/wedlets/wedlet";
import {POPUP} from "back/commons/widgets/popups";
import {JSX} from "lib/commons/xml/dom";
import {BoxId} from "back/edit/wed/wedlets/box/boxId";
import {IO} from "lib/commons/io/io";
import {ITEM} from "lib/wsp/item";

export class BoxCtId extends BoxId {
	//reg: IReg<IItemUiEnv>;
	protected onFragmentIdChanged() {
		this.setAttribute("title", "Identifiant : " + this.fragmentId);
	}
}

AgEltBoxSelection(BoxCtId, {selMode: 'box', actionsLists: ['actions:wed:box-ctid', 'actions:wed:box-id'], groupOrder: '* edit'});

REG.reg.registerSkin("wsp-box-ctid", 1, /* language=CSS */ `
	:host {
		tab-index: 0;
		z-index: 2;
		cursor: default;
		user-select: none;
	  color: var(--fade-color);
	  font-style: italic;
		border: 1px solid var(--border-color);
		border-radius: 0.75rem;
		height: 1.5em;
		width: 1.5em;
	  align-self: end;
		text-align: center;
		margin: 0.5em 0.5em -2em;
	}

	:host(:focus) {
		outline: var(--focus-outline);
	}
`);

window.customElements.define("wsp-box-ctid", BoxCtId);

REG.reg.addToList("actions:wed:box-ctid", "changeId", 1, new Action<IWedletActionCtx>("changeId")
	.setLabel("Changer d'identifiant")
	.setGroup("edit")
	.setIcon("/@skin@/edit/wed/box/changeId.svg")
	.setVisible((ctx: IWedletActionCtx) => !ctx.wedlet.isVirtual() && isEditableWedlet(ctx.wedlet) && ctx.wedlet.editMode === EWedletEditMode.write)
	.setEnabled((ctx: IWedletActionCtx) => ctx.wedlet.wedMgr.reg.hasPerm("action.wed#change.box-ctid"))
	//.requireEnabledPerm("action.wed#change.box-id") FIXME6 : manque le reg dans IWedletActionCtx pour faire fonctionner checkObjectRootPerm
	.setExecute(async (ctx: IWedletActionCtx) => {
		if (await POPUP.confirm("Attention : Changer d'identifiant aura pour effet de casser les liens établis vers ce fragment.",
			ctx.focusedElt, {okLbl: "Changer d'identifiant", kind: "warning"})) {
			const wedMgr = ctx.wedlet.wedMgr;
			const reg = wedMgr.reg as IReg<IItemUiEnv>;
			const wsp = reg.env.wsp;
			const id = await wsp.wspServer.config.wspSvcUrl.resolve(wsp.code + "/ctId").fetchText(IO.qs("param", ITEM.extractItemCode(reg.env.longDesc.srcUri)), {method: "POST"});
			ctx.wedlet.wedMgr.docHolder.newBatch().setAttr(ctx.wedlet.wedAnchor, id).doBatch();
		}
	})
);